import { render, staticRenderFns } from "./EnablingTypeCategoriesRegistryNewForm.vue?vue&type=template&id=e1e8a4aa"
import script from "./EnablingTypeCategoriesRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./EnablingTypeCategoriesRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports